import { motion } from "framer-motion";

/**
 * Shared caption frame used by every demo scene.
 *
 * The unifying visual element of the story. Same border, same padding,
 * same typography in every scene — so scenes 1–6 read as the same
 * publication, not six different design grammars stitched together.
 *
 *   eyebrow  — small uppercase scene label (optional)
 *   title    — optional larger serif line (used by Scene 1 / the title card)
 *   body     — the narration prose
 */
export const SceneCaption = ({ eyebrow, title, body, delay = 0, children }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
    className="border border-[#DDD9CF] bg-white rounded-md px-6 py-5 xl:px-7 xl:py-6"
    data-testid="scene-caption"
  >
    {eyebrow && (
      <div className="text-[10px] uppercase tracking-[0.20em] text-[#C4521E] mb-3">
        {eyebrow}
      </div>
    )}
    {title && (
      <h1 className="font-serif-display text-4xl xl:text-5xl text-[#1A1814] leading-[1.05] tracking-tight">
        {title}
      </h1>
    )}
    {body && (
      <p
        className={`${
          title ? "mt-4 text-base xl:text-lg" : "text-base xl:text-lg"
        } text-[#1A1814] font-serif-display italic leading-relaxed`}
      >
        {body}
      </p>
    )}
    {children}
  </motion.div>
);
